import "../../components/layout/Stack/Stack.js";
import l from "../../components/layout/Box/Box.js";
import { styledWithConfig as a } from "../../components/layout/Box/utils.js";
import "react/jsx-runtime";
import "react";
import "../../index-CZ8zjHGv.js";
import "../../components/layout/Center/Center.js";
import "../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../components/layout/Columns/ColumnsContext.js";
import { useDom as f } from "../../context/Dom.js";
const u = a("a");
function A({
  to: t,
  disabled: o,
  newTab: r,
  navLink: e,
  replace: i,
  styleProps: p,
  state: n
}) {
  const { Link: s, NavLink: m } = f();
  return o ? { Component: l } : k(t) ? {
    Component: u,
    linkProps: {
      href: t,
      rel: "nofollow noopener noreferrer",
      target: r === !1 ? null : "_blank"
    }
  } : e ? {
    Component: m,
    linkProps: {
      to: t,
      target: r ? "_blank" : null,
      activeStyle: p.activeNavLinkStyles,
      state: n ?? (typeof t != "string" ? t.state : void 0)
    }
  } : {
    Component: s,
    linkProps: {
      replace: i,
      to: t,
      target: r ? "_blank" : null,
      state: n ?? (typeof t != "string" ? t.state : void 0)
    }
  };
}
function k(t) {
  return typeof t == "string" && (t.startsWith("http") || t.startsWith("mailto:"));
}
export {
  k as isLinkExternal,
  A as useGetLinkComponentAndProps
};
